<template>
    <div id="app">
        <div class="app-widget app-widget--center">
            <div class="app-widget__end app-widget__end--declined">
                <h1>К сожалению, оплата вашей онлайн консультации не прошла</h1>
                <div class="app-widget__text">
                    Вы получите ссылку для оплаты на указанные при записи мобильный телефон и электронную почту. При возникновении вопросов свяжитесь с нами по телефону
                    <a href="tel:0074957903553" class="app-widget__text-link">+7(495)790-35-53</a>
                </div>
                <div class="app-widget__end-container">
                    <a href="/" class="button app-widget__end-btn">На главную</a>
                    <a v-bind:href="`${url}/${$route.params.id}`" class="button app-widget__end-btn app-widget__end-btn--repeat">Повторить оплату</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'declined',
    data() {
      return {
        url: window.TELEMEDICINE_PAY_FORM_URL
      }
    }
  }
</script>

<style lang="sass">
.app-widget
    &__end--declined
        h1
            margin: 30px 0

    &__end-btn--repeat
        background-color: #1BB3B2!important
        color: #fff!important

        &:hover
            background-color: #fff!important
            color: #222!important

</style>
